import Vue from 'vue';
import VueRouter from 'vue-router';

// 独立模块
import Index from '../components/Index';
import Login from '../components/Login';
import Intercept from '../components/Intercept'; // 拦截提示页面
import NotFound from '../components/NotFound';

// 店铺首页
import ShopIndex from '../components/shop/Index';
// 订单管理模块
import NewOrderList from '../pages/bnb/order/List';
import OrderList from '../components/order/List';
import OrderDetail from '../components/order/Detail';
import OrderConsumer from '../components/order/Consumer'; // 订单扫码核销落地页

// 房态管理模块
import RoomStatus from '../components/room/RoomStatus';

// 价格管理模块
import PriceList from '../components/price/List';
import PriceDetail from '../components/price/Detail';
import PriceEdit from '../components/price/Edit';

// 财务管理模块
import Financial from '../components/financial/Main';
import FinancialReport from '../components/financial/Report';
import FinancialDetail from '../components/financial/Detail';
import FinancialAmountDue from '../components/financial/AmountDue';
import FinancialOrderDetail from '../components/financial/OrderDetail';

// 会员管理模块
import Member from '../components/member/Main';
import MemberHome from '../components/member/Home';
import RebateBill from '../components/member/RebateBill';
import RebateDetail from '../components/member/RebateDetail';

// 优惠券管理模块
import Coupon from '../components/coupon/Main';
import CouponHome from '../components/coupon/Home';

// 店铺管理模块
import Manage from '../components/manage/Manage';
import ManagerAdd from '../components/manage/ManagerAdd';
import ManagerEdit from '../components/manage/ManagerEdit';
import ManagerDetail from '../components/manage/ManagerDetail';

// 团购订单模块
import TuanOrderList from '../components/tuan_order/List';
import TuanOrderDetail from '../components/tuan_order/Detail';
import TuanOrderConsumer from '../components/tuan_order/Consumer'; // 订单扫码核销落地页

// 团购销控模块
import TuanGoodsStatus from '../components/tuan_goods/GoodStatus';

// 团购改价模块
import TuanPriceList from '../components/tuan_price/List';
import TuanPriceDetail from '../components/tuan_price/Detail';
import TuanPriceEdit from '../components/tuan_price/Edit';

// 团购账单模块
import TuanFinancial from '../components/tuan_financial/Main';
import TuanFinancialReport from '../components/tuan_financial/Report';
import TuanFinancialDetail from '../components/tuan_financial/Detail';
import TuanFinancialAmountDue from '../components/tuan_financial/AmountDue';
import TuanFinancialOrderDetail from '../components/tuan_financial/OrderDetail';

// 团购定制需求
import TuanCustomMain from '../components/tuan/TuanCustomMain';
import TuanCustomList from '../components/tuan/TuanCustomList';
import TuanCustomDetail from '../components/tuan/TuanCustomDetail';

//活动报名确认及核销
import ActivitySignupDetail from '../components/activity/ActivitySignupDetail';

Vue.use(VueRouter);


export default new VueRouter({
    saveScrollPosition: true,
    // mode: 'history',
    routes: [
        {
            name: 'index',
            path: '/',
            component: Index
        },
        {
            name: 'login',
            path: '/login',
            component: Login
        },
        {
            name: 'intercept',
            path: '/intercept',
            component: Intercept
        },
        {
            path: '/shop/:shopId', component: ShopIndex,
        },
        // 订单逻辑，所有路由公用一个router-view
        {
            path: '/shop/:shopId/neworders',component: NewOrderList
        },
        {
            path: '/shop/:shopId/orders',component: OrderList, meta: { keepAlive: true }
        },
        {
            path: '/shop/:shopId/order/:id', component: OrderDetail
        },
        {
            // 扫码订单核销落地页
            path: '/shop/:shopId/order/consumer/:id/:voucherNo', component: OrderConsumer
        },
        {
            path: '/shop/:shopId/room/status', component: RoomStatus,
        },
        {
            path: '/shop/:shopId/prices', component: PriceList
        },
        {
            path: '/shop/:shopId/room/:roomId/price', component: PriceDetail,
        },
        {
            path: '/shop/:shopId/room/:roomId/price/edit', component: PriceEdit,
        },
        {
            path: '/shop/:shopId/financial/', component: Financial,
            children: [
              { path: '', component: FinancialReport },
              { path: 'detail/:billNo', component: FinancialDetail },
              { path: 'due/:billNo*', component: FinancialAmountDue },
              { path: 'orderDetail/:id', component: FinancialOrderDetail }
            ]
        },
        {
            path: '/shop/:shopId/member/', component: Member,
            children: [
              { path: '', component: MemberHome },
              { path: 'rebateBill/:promoteAccountId/:withdrawalNo*', component: RebateBill },
              { path: 'rebateDetail/:promoteAccountId/:id', component: RebateDetail }
            ]
        },
        {
            path: '/coupon/', component: Coupon,
            children: [
                { path: '', component: CouponHome },
            ]
        },
        {
            path: '/shop/:shopId/manage', component: Manage,
        },
        {
            path: '/shop/:shopId/manage/manager/add', component: ManagerAdd,
        },
        {
            path: '/shop/:shopId/manage/manager/:managerId/edit', component: ManagerEdit,
        },
        {
            path: '/shop/:shopId/manage/manager/:managerId/detail', component: ManagerDetail,
        },


        // 团购订单逻辑，所有路由公用一个router-view
        {
            path: '/shop/:shopId/tuanOrders',component: TuanOrderList, meta: { keepAlive: true }
        },
        {
            path: '/shop/:shopId/tuanOrder/:id/user/:userId', component: TuanOrderDetail
        },
        {
            // 扫码订单核销落地页
            path: '/shop/:shopId/tuanOrder/consumer/:id/:voucherNo', component: TuanOrderConsumer
        },
        {
            path: '/shop/:shopId/tuanGoods/status', component: TuanGoodsStatus,
        },
        {
            path: '/shop/:shopId/tuanPrices', component: TuanPriceList
        },
        {
            path: '/shop/:shopId/tuanGoods/:goodsId/price', component: TuanPriceDetail,
        },
        {
            path: '/shop/:shopId/tuanGoods/:goodsId/price/edit', component: TuanPriceEdit,
        },
        {
            path: '/shop/:shopId/tuanFinancial/', component: TuanFinancial,
            children: [
              { path: '', component: TuanFinancialReport },
              { path: 'detail/:billNo', component: TuanFinancialDetail },
              { path: 'due/:billNo*', component: TuanFinancialAmountDue },
              { path: 'orderDetail/:id', component: TuanFinancialOrderDetail }
            ]
        },
        {
            path: '/shop/:shopId/custom/', component: TuanCustomMain,
            children: [
                { path: '', component: TuanCustomList },
                { path: 'detail/:orderNo', component: TuanCustomDetail }
            ]
        },
        {
            path: '/shop/:shopId/activity/:actId/mobile/:mobile',component: ActivitySignupDetail,
        },
        {
            /* Not Found 路由，必须是最后一个路由 */
            name: '404',
            path: '*',
            component: NotFound
        }

    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js